import type { Block, ProductBlockContent } from '@/types';

interface ProductBlockProps {
  block: Block;
}

function ProductBlock({ block }: ProductBlockProps) {
  const content = block.content as ProductBlockContent;

  return (
    <div className="p-4 border border-gray-300 rounded">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <h3 className="text-lg font-semibold">{content.name || 'Product naam'}</h3>
          {content.description && (
            <p className="text-sm text-muted-foreground">{content.description}</p>
          )}
        </div>
        <div className="text-right">
          <p className="text-sm">Aantal: {content.quantity}</p>
          <p className="text-sm">Prijs: €{content.price.toFixed(2)}</p>
          {content.discount && content.discount > 0 && (
            <p className="text-sm text-green-600">Korting: {content.discount}%</p>
          )}
          <p className="text-lg font-semibold mt-2">
            Totaal: €{content.total.toFixed(2)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProductBlock;
